import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { ApplicationAuditsByApplicationDto, AssignAuditorToApplicationDto } from "./application-audits.dto";
import { AuditorDto } from "../auditors/auditors.dto";

const services = {
  GetByApplicationId(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationAuditsByApplicationDto>(
      `ApplicationAudits/by-application/${applicationId}`,
      config
    );
  },
  AuditorApprove(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<ApplicationAuditsByApplicationDto>(
      `ApplicationAudits/auditor-approve/${applicationId}`,
      config
    );
  },
  AuditorReject(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<ApplicationAuditsByApplicationDto>(
      `ApplicationAudits/auditor-reject/${applicationId}`,
      config
    );
  },
  AssignAuditorToApplication(
    dto: AssignAuditorToApplicationDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<AuditorDto>(`ApplicationAudits`, dto, config);
  },
};

export default services;
